import { MODULE_NAMES, USER_FIELDS, GROUP_ID_SEPARATOR } from '../constants/userContextConstants';

export const enrichUserData = (userData, modules, userGroups, isAdmin) => {
    return {
        ...userData,
        hasModule: (moduleName) => modules.includes(moduleName),
        hasGroup: (groupId) => userGroups.includes(groupId),
        canAccess: (identifier) => {
            if (isAdmin) return true;

            if (identifier && identifier.includes(GROUP_ID_SEPARATOR)) {
                return userGroups.includes(identifier);
            }

            return modules.includes(identifier);
        }
    };
};

export const buildAccessRights = (modules) => {
    return {
        [MODULE_NAMES.HOME_PAGE]: modules.includes(MODULE_NAMES.HOME_PAGE),
        [MODULE_NAMES.SALES_PROMOTIONS_PAGE]: modules.includes(MODULE_NAMES.SALES_PROMOTIONS_PAGE),
        [MODULE_NAMES.PERMISSIONS_PAGE]: modules.includes(MODULE_NAMES.PERMISSIONS_PAGE),
        [MODULE_NAMES.APROVE_LINES_PAGE]: modules.includes(MODULE_NAMES.APROVE_LINES_PAGE),
        [MODULE_NAMES.OBLIGO_EXCEPTION_PAGE]: modules.includes(MODULE_NAMES.OBLIGO_EXCEPTION_PAGE),
        [MODULE_NAMES.VIEW_OBLIGO_DATA]: modules.includes(MODULE_NAMES.VIEW_OBLIGO_DATA),
        [MODULE_NAMES.CHECK_INVOICES_PAGE]: modules.includes(MODULE_NAMES.CHECK_INVOICES_PAGE),
        [MODULE_NAMES.PURCHASE_INVOICE_PAGE]: modules.includes(MODULE_NAMES.PURCHASE_INVOICE_PAGE),
        [MODULE_NAMES.FORM161_PAGE]: modules.includes(MODULE_NAMES.FORM161_PAGE),
        [MODULE_NAMES.ADMIN]: modules.includes(MODULE_NAMES.ADMIN),
        [MODULE_NAMES.TIME_LINE_PAGE]: modules.includes(MODULE_NAMES.TIME_LINE_PAGE),
        [MODULE_NAMES.ELDAN_PRINTER_PAGE]: modules.includes(MODULE_NAMES.ELDAN_PRINTER_PAGE),
        [MODULE_NAMES.CHEMO_RECORDS_PAGE]: modules.includes(MODULE_NAMES.CHEMO_RECORDS_PAGE),
        [MODULE_NAMES.IMPORT_MANAGEMENT_PAGE]: modules.includes(MODULE_NAMES.IMPORT_MANAGEMENT_PAGE),
        [MODULE_NAMES.EMAIL_TRACKING_PAGE]: modules.includes(MODULE_NAMES.EMAIL_TRACKING_PAGE),
        [MODULE_NAMES.RESEARCH_MONITOR_PAGE]: modules.includes(MODULE_NAMES.RESEARCH_MONITOR_PAGE),
        [MODULE_NAMES.QR_CODE_DEVICE_MAPPING_PAGE]: modules.includes(MODULE_NAMES.QR_CODE_DEVICE_MAPPING_PAGE),
        [MODULE_NAMES.TRADE_DELAY_PAGE]: modules.includes(MODULE_NAMES.TRADE_DELAY_PAGE),
        [MODULE_NAMES.FUEL_CONTROL_PAGE]: modules.includes(MODULE_NAMES.FUEL_CONTROL_PAGE),
        [MODULE_NAMES.HRCV_MATCHING_PAGE]: modules.includes(MODULE_NAMES.HRCV_MATCHING_PAGE),
        [MODULE_NAMES.PROMOTIONS_SYSTEM_PAGE]: modules.includes(MODULE_NAMES.PROMOTIONS_SYSTEM_PAGE),
        [MODULE_NAMES.DPL_STATISTICS_PAGE]: modules.includes(MODULE_NAMES.DPL_STATISTICS_PAGE),
        [MODULE_NAMES.ELDAN_AGENT_PAGE]: modules.includes(MODULE_NAMES.ELDAN_AGENT_PAGE),
        [MODULE_NAMES.LIBERTY_MEDICAL_PAGE]: modules.includes(MODULE_NAMES.LIBERTY_MEDICAL_PAGE),
        [MODULE_NAMES.MANAGERS_DASHBOARD_PAGE]: modules.includes(MODULE_NAMES.MANAGERS_DASHBOARD_PAGE),
        [MODULE_NAMES.PURCHASE_ORDER_MANAGEMENT_PAGE]: modules.includes(MODULE_NAMES.PURCHASE_ORDER_MANAGEMENT_PAGE),
        [MODULE_NAMES.SAL_COMMITTEE_PAGE]: modules.includes(MODULE_NAMES.SAL_COMMITTEE_PAGE),
        [MODULE_NAMES.SAL_PRESENTATION_PAGE]: modules.includes(MODULE_NAMES.SAL_PRESENTATION_PAGE),
    };
};

export const buildUserData = (response, account, userGroups, isAdmin) => {
    const {
        modules,
        userBranchesList,
        fullName,
        email,
        priorityUserName,
        roles,
        _id,
        hospital,
        tradeDelayRole
    } = response;

    const accessRights = buildAccessRights(modules);

    return {
        [USER_FIELDS.ID]: _id,
        [USER_FIELDS.ACCESS_RIGHTS]: accessRights || {},
        [USER_FIELDS.ROLES]: roles,
        [USER_FIELDS.USER_BRANCHES_LIST]: userBranchesList || [],
        [USER_FIELDS.FULL_NAME]: fullName,
        [USER_FIELDS.EMAIL]: email,
        [USER_FIELDS.PRIORITY_USER_NAME]: priorityUserName || '',
        [USER_FIELDS.HOSPITAL]: hospital || '',
        [USER_FIELDS.GROUPS]: userGroups,
        [USER_FIELDS.IS_ADMIN]: isAdmin,
        [USER_FIELDS.TRADE_DELAY_ROLE]: tradeDelayRole || null,
    };
};
